/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerFindAllQueryResponse, SkillsControllerFindAllQueryParams, SkillsControllerFindAll401, SkillsControllerFindAll403 } from "../../models/skillsController/SkillsControllerFindAll";

function getSkillsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/skills` as const }  
  return res
}

/**
 * @summary Get visible skills for the current context
 * {@link /api/v1/skills}
 */
export async function skillsControllerFindAll(params: SkillsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillsControllerFindAllQueryResponse, ResponseErrorConfig<SkillsControllerFindAll401 | SkillsControllerFindAll403>, unknown>({ method : "GET", url : getSkillsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}